import { render, staticRenderFns } from "./friendsDropdown.vue?vue&type=template&id=28069fe9&"
import script from "./friendsDropdown.vue?vue&type=script&lang=js&"
export * from "./friendsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./friendsDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports